import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts, ValidatedResponse } from "@ofqual/portal-core/core/types";
import { SubjectModel } from "../domain/SubjectModel";

export class ExpertiseService extends BaseRemoteService {

  public async addExpertise(
    expertise: SubjectModel,
    opts: Opts
  ): Promise<ValidatedResponse<SubjectModel>> {
    const url = `${this.apiRoot}/expertise`;
    const response: SubjectModel = await super.postRequest(
      url,
      expertise,
      opts
    );
    return { isValid: true, data: response };
  }


}